export default __webpack_public_path__ + "media/transfer_window/terms_and_conditions-98198080.mp4";